import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";

const RUNTIME_RULES_URL = () => resolveApiUrl("/api/seo-guard/runtime-rules");
const REQUIRED_LOCKED_PATHS = ["/admin", "/dashboard", "/p", "/api"];

let runtimeRulesCache = undefined;
let runtimeRulesPromise = null;

const toBoolean = (value, defaultValue = false) =>
  typeof value === "boolean" ? value : defaultValue;

const buildRuleFromRuntime = (row) => {
  if (!row || typeof row !== "object") {
    return null;
  }

  const source = String(row.pattern_source || "").trim();
  if (!source) {
    return null;
  }

  let pattern;
  try {
    pattern = new RegExp(source);
  } catch {
    return null;
  }

  return {
    pattern,
    type: String(row.type || "unknown"),
    locked: toBoolean(row.locked, false),
    index: toBoolean(row.index_enabled, false),
    follow: toBoolean(row.follow_enabled, true),
    sitemap: toBoolean(row.sitemap_enabled, false),
    disallow: toBoolean(row.disallow_enabled, false),
    allowAgentOverride: toBoolean(row.allow_agent_override, false),
    priority: Number.isFinite(Number(row.priority)) ? Number(row.priority) : 0,
  };
};

const hasRequiredLockedCoverage = (globalRules) => {
  return REQUIRED_LOCKED_PATHS.every((path) =>
    globalRules.some((rule) => rule.locked === true && rule.disallow === true && rule.pattern.test(path))
  );
};

export function normalizeRuntimeRulesPayload(payload) {
  if (!payload || typeof payload !== "object") {
    return null;
  }

  const globalRules = (payload.global_rules || []).map(buildRuleFromRuntime).filter(Boolean);
  const templateRules = (payload.template_rules || []).map(buildRuleFromRuntime).filter(Boolean);

  if (!globalRules.length || !templateRules.length) {
    return null;
  }

  if (!hasRequiredLockedCoverage(globalRules)) {
    return null;
  }

  return {
    globalRules: [...globalRules].sort((a, b) => a.priority - b.priority),
    templateRules: [...templateRules].sort((a, b) => a.priority - b.priority),
  };
}

export async function loadRuntimeSeoRules() {
  if (runtimeRulesCache !== undefined) {
    return runtimeRulesCache;
  }
  if (runtimeRulesPromise) {
    return runtimeRulesPromise;
  }

  runtimeRulesPromise = (async () => {
    try {
      const response = await axios.get(RUNTIME_RULES_URL(), {
        withCredentials: true,
      });
      const normalized = normalizeRuntimeRulesPayload(response?.data);
      runtimeRulesCache = normalized || null;
      return runtimeRulesCache;
    } catch (error) {
      runtimeRulesCache = null;
      return null;
    } finally {
      runtimeRulesPromise = null;
    }
  })();

  return runtimeRulesPromise;
}

export function resetRuntimeSeoRulesCache() {
  runtimeRulesCache = undefined;
  runtimeRulesPromise = null;
}
